import styled from 'styled-components';

export const CardBaseWrapper = styled.div`
  > div {
    flex-direction: column;
    align-items: start;

    padding: 24px 20px;
    gap: 12px;

    > svg {
      margin-bottom: 4px;
    }

    > button {
      padding-inline-start: 0px;
    }
  }
`;

export const ModalBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
